<template lang="pug">
  div.vkb_nak.vkb_nak_fsoel.vkb_nak_bedarfscheck_wohnen
    .large-12.columns(ref="heading")
      .row(ref="rented")
        .small-12.columns
          hr.topspace

        .large-6.medium-12.small-12.columns.form-break-spacing
          h3.feedback
            span.feedback-before(:class="!!subjectId && 'validated'")
            | Welche Art von Immobilie besitzen Sie?

        .large-6.medium-12.small-12.columns
          n-radio(
            :value="subjectId"
            :id="`subject`"
            :options="subjects"
            @input="onSelectSubject"
          )

        .small-12.columns
          hr

      .row
        template(v-if="!!subjectId")
          .small-12.columns(v-if="subjectId !== 'Miete'")
            .row.form-spacing
              .large-6.medium-12.small-12.columns.form-break-spacing
                h3.feedback
                  span.feedback-before(:class="rented !== null && 'validated'")
                  | Wird Ihre Immobilie ganz oder zum Teil vermietet?

              .large-6.medium-12.small-12.columns
                n-radio(
                  :value="rented"
                  :id="`rented`"
                  :options="rentedOptions"
                  @input="onSelectRented"
                )
            hr

          //.small-12.columns(ref="relationship")
            .row.form-spacing
              .large-6.medium-12.small-12.columns.form-break-spacing
                h3.feedback
                  span.feedback-before(:class="relationship !== null && 'validated'")
                  | Was beschreibt Ihren Haushalt am ehesten?

              .large-6.medium-12.small-12.columns
                n-radio(
                  :value="relationship"
                  :id="`relationship`"
                  :options="relationshipOptions"
                  @input="onSelectRelationship"
                )
            hr

      a(ref="insurance-list")
      .row.tk-vkb-fullsizebg1.tk-vkb-expand(v-if="insurances.length > 0")
        .mt-10.mb-6.large-12.medium-12.small-12.columns
          .row
            .small-12.columns
              h2 Empfohlene Produkte
              hr.topspace

          .row.tk-vkb-flex-container
            .small-12.medium-6.large-4.columns.tk-vkb-flex-wrapper.mt-6(
              v-for="(insurance, index) in insurances"
              :key="index"
            )
              insurance-card(
                :name="insurance.name"
                :icon="insurance.icon"
                :image="insurance.image"
                :html="decodeHtml(insurance.html)"
                :link-more="insurance.more_info_url"
                :link-offer="insurance.offer_url"
                :link-calc="insurance.calculate_online_url"
                :can-complete="insurance.calculate_online_can_complete"
                :link-watch="insurance.watch_live_url"
                :hide-favorite="true"
                @click-offer="triggerActionEvent(`03/angebot_anfordern/${ insurance.internal_code }`, trackingModuleType)"
                @click-calc="triggerActionEvent(`03/beitrag_berechnen/${ insurance.internal_code }`, trackingModuleType)"
              )

</template>

<script>
import logic from './logic.js';

export default {
  name: 'bedarfscheck_wohnen',

  mixins: [
    logic,
  ],

  created() {
    window.addEventListener('scroll', this.onScroll);
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  },
};
</script>



// WEBPACK FOOTER //
// src/apps/bedarfscheck_wohnen/fsoel.vue